const mutations = {
    setJobList(state, data) {
        state.jobList = data;
    },
    setJob(state, data) {
        state.serviceJob.serviceJobId = data.serviceJobId;
        state.serviceJob.label = data.label;
        state.serviceJob.serviceId = data.serviceId;
        state.serviceJob.laborCharges = data.laborCharges;
        state.serviceJob.jobs = [];
        if (data.service && data.service.serviceCategoryId) {
            state.serviceJob.serviceCategoryId = data.service.serviceCategoryId;
        }
    },
    resetJob(state) {
        state.serviceJob = {
            label: '',
            serviceId: null,
            serviceCategoryId: null,
            laborCharges: 0


        }
    }

}
export default mutations;